import MUIRadio from "@mui/material/Radio";

const Radio = MUIRadio;

export default Radio;
